/* eslint-disable import/no-cycle */
/* eslint-disable unicorn/no-useless-undefined */
/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable unicorn/consistent-function-scoping */
import { LoadingButton } from "@mui/lab";
import { CircularProgress } from "@mui/material";
import Box from "@mui/material/Box/Box";
import Divider from "@mui/material/Divider/Divider";
import Stack from "@mui/material/Stack/Stack";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography/Typography";
import jwtDecode from "jwt-decode";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { HttpService } from "../../../constants/HTTPService";
import useModal from "../../../hooks/use-modal";
import { IJwtTokenData } from "../../../interfaces/IJwtTokenData";
import { publicRoutes } from "../../../routes/public";
import { persistor } from "../../../store";
import {
  setNewProfile,
  setNewProfileAvatar,
  setNewProfileRole,
} from "../../../store/newProfile/slice";
import { loginStyle } from "../../../styles/container/login";
import {
  removeAuthToken,
  setAuthToken,
  setIsBypassLogin,
  setLastVisitedPage,
} from "../../../utils/token";
import Loading from "../../loading/loading";
import { getRoleNameProfileSA } from "./api-endpoint/callApi";

export function LoginContentByPass() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showModal } = useModal();

  const [loadingActive, setLoadingActive] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [emailLogin, setEmailLogin] = useState("");
  const [passwordLogin, setPasswordLogin] = useState("");

  const cleanupAuthData = () => {
    dispatch(setNewProfile(undefined));
    dispatch(setNewProfileRole(undefined));
    dispatch(setNewProfileAvatar(undefined));

    persistor.purge();
    sessionStorage.clear();
    localStorage.clear();

    removeAuthToken();
  };

  const processAuthToken = async (token: string) => {
    setLoadingActive(true);

    // Decoding token
    const decodedToken: IJwtTokenData = jwtDecode(token);

    // Set Storage
    setAuthToken(token);
    setIsBypassLogin(true);

    // Set profile picture to undefined
    dispatch(setNewProfileAvatar(undefined));

    // Get Role Profile
    const getRoleProfile = await getRoleNameProfileSA();

    // New Dispatch
    dispatch(setNewProfile(decodedToken));
    dispatch(setNewProfileRole(getRoleProfile));
    dispatch(setNewProfileAvatar(undefined));

    // Finish Loading
    setLoadingActive(false);

    // Redirect to the appropriate page
    navigate("/", { replace: true });
  };

  const handleByPass = async () => {
    setIsLoading(true);
    const currentUrl = window.location.pathname;
    const excludedPaths = publicRoutes
      .map((route) => route.path)
      .filter((path): path is string => path !== undefined);

    if (!excludedPaths.includes(currentUrl)) {
      setLastVisitedPage(currentUrl);
    }

    try {
      // Get Token from API
      const authResponse = await HttpService.getAuthorizationTokenBypass(
        emailLogin,
        passwordLogin
      );

      const { tokenData } = authResponse.data;

      // Process the token
      await processAuthToken(tokenData.token);
    } catch (error) {
      console.log("Error fetching data:", error);
      setLoadingActive(false);
      cleanupAuthData();

      const errorMessage =
        error instanceof Error
          ? error.message
          : "An error occurred during login, please try again.";

      showModal({
        title: "Login Failed",
        message: errorMessage,
        options: {
          variant: "failed",
        },
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Stack
      component="section"
      sx={loginStyle.contentStack}
      style={{ padding: "0 0 0 2%", gap: "30px" }}
    >
      <Box
        sx={loginStyle.contentStackBox}
        component="form"
        onSubmit={(e) => {
          e.preventDefault();
          handleByPass();
        }}
      >
        <div style={{ marginBottom: "1rem" }}>
          <Typography variant="h6" gutterBottom>
            Email
          </Typography>
          <TextField
            placeholder="Isi Email"
            fullWidth
            onChange={(e) => setEmailLogin(e.target.value)}
          />
        </div>

        <div style={{ marginBottom: "1rem" }}>
          <Typography variant="h6" gutterBottom>
            Password
          </Typography>
          <TextField
            placeholder="Isi Password"
            type="password"
            fullWidth
            onChange={(e) => setPasswordLogin(e.target.value)}
          />
        </div>

        <LoadingButton
          variant="contained"
          onClick={handleByPass}
          type="submit"
          loading={isLoading || loadingActive}
          disabled={isLoading || loadingActive}
          loadingIndicator={
            <CircularProgress sx={{ color: "#FFFFFF" }} size="20px" />
          }
          sx={{
            marginTop: "1rem",
            marginBottom: "1rem",
          }}
        >
          By Pass
        </LoadingButton>

        <Typography
          variant="caption"
          sx={loginStyle.contentStackBoxTypography2}
        >
          Application Legal Support Agreement
        </Typography>
        <Divider sx={loginStyle.contentStackBoxDivider} />
      </Box>
      <Box
        component="img"
        src="/assets/image/alesa-login.png"
        sx={loginStyle.contentStackBoxImgByPass}
      />
      <Loading open={loadingActive} />
    </Stack>
  );
}
